$(document).ready(function () {
    // Dynamic active step update
    function updateActiveStep() {
        const stepBar = $('.stepBar');
        stepBar.removeClass('active');
        $('.subscription-step').each(function (index) {
            if ($(this).hasClass('active')) {
                stepBar.eq(index).addClass('active');
            }
        });
    }
    
    // Dynamic step counter
    function updateStepCount() {
        const steps = $('.subscription-step');
        const progressBarWrapper = $('.progressBar-wrapper');
        progressBarWrapper.empty();
        
        steps.each(function () {
            if (!$(this).hasClass('hidden')) {
                const stepBar = $('<span>').addClass('stepBar');
                progressBarWrapper.append(stepBar);
            }
        });
        // Initial active step
        updateActiveStep();
        
    }
    
    setTimeout(function () {
        $('.introduction-popup').addClass('active');
    }, 100);
    
    $('.show-popup').on('click', function () { 
        $('.introduction-popup').addClass('active');
    });
    
    $('.close-popup, .introduction-popup').on('click', function () {
        $('.introduction-popup').removeClass('active');
        $('.introduction-popup-overlay').addClass('hidden');
    });
    
    updateStepCount();
    
    // Dynamic step card activation
    $('.option-selection').find('.option-card').on('click', function () {
        $(this).closest('.option-selection').find('.option-card').removeClass('active');
        $(this).addClass('active');
    });
    
    // Construct full variant selection
    function chooseVariant() {
        const isSliderActive = $('.frequency-value').length && $('.frequency-slider').length;
        let frequencyString;
        
        if (isSliderActive) {
            frequencyString = $('.frequency-value').text().trim();
            const frequencyNumber = parseInt(frequencyString.match(/^\d+/)[0], 10);
            const activeFrequencyOption = $('.frequency-selector.active').find(`option[value="${frequencyNumber}"]`);
            if (activeFrequencyOption.length) {
                frequencyString = activeFrequencyOption.data('frequency');
            }
            
        } else {
            frequencyString = $('.frequency-selector.active').data('frequency');
        }
        
        const blend = $('.blend-selector.active').data('option1');
        const productType = $('.step1-card.active').data('handle');
        
        if (!frequencyString || !blend || !productType) {
            return;
        }
        
        const $productSelect = $('select[data-handle="' + productType + '"]');
        const fullVariant = blend + ' / ' + frequencyString;
        
        
        let $optionToSelect = $productSelect.find('option[data-title="' + fullVariant + '"]');
        
        
        // If exact match not found, try flexible matching for "blend / number" pattern
        if ($optionToSelect.length === 0) {
            
            const frequencyNumber = parseInt(frequencyString.match(/^\d+/)?.[0], 10);
            if (!isNaN(frequencyNumber)) {
                const flexiblePattern = blend + ' / ' + frequencyNumber;
                $optionToSelect = $productSelect.find('option[data-title^="' + flexiblePattern + '"]');
            }
        } else {
        }
        
        if ($optionToSelect.length === 0 && isSliderActive) {
            const $blendOptions = $productSelect.find('option[data-title^="' + blend + ' /"]');
            let highestFreqOption = null;
            let maxFreqNum = -1;
            
            $blendOptions.each(function() {
                const title = $(this).attr('data-title');
                if (title) {
                    const currentFreqNum = parseInt(title.split(' / ')[1], 10);
                    if (!isNaN(currentFreqNum) && currentFreqNum > maxFreqNum) {
                        maxFreqNum = currentFreqNum;
                        highestFreqOption = $(this);
                    }
                }
            });
            
            $optionToSelect = highestFreqOption;
        }
        
        if ($optionToSelect && $optionToSelect.length > 0) {
            $optionToSelect.prop('selected', true);
        }
    }
    
    // Today trial summary
    
    $('.blend-selector').on('click', function () {
        calculateTotalPrice();
        $('.blend-selector').removeClass('active');
        $(this).addClass('active');
        let notes = $('.blend-selector.active').data('explanatory-notes');
        //    Update the trial items wrap with the selected blend details
        $('.trial-items-wrap .variant-item').find('.metafield-desc').html(notes).addClass('active');
        $('.trial-items-wrap .variant-item').find('.item-title').html($(this).data('option1'));
        
        // Prepend selected blend image to .trial-items-wrap
        var blendImg = $(this).find('img').clone().addClass('item-img');
        $('.trial-items-wrap').find('.item-img').remove(); // Remove previous image if any
        $('.trial-items-wrap').find('.variant-item').prepend(blendImg);
    });
    
    // Upsell summary
    
    $('.step4-card').on('click', function () { 
        if ($(this).hasClass('active') && $(this).hasClass('step4-upsell')) {
            let upsellPrice = $(this).data('upsell-price');
            let upsellTitle = $(this).find('.option-name').text();
            let upsellImg = $(this).find('img').clone().addClass('item-img');
            let upsellDescription = $(this).data('description');
            const upsellItem = $('.trial-items-wrap .upsell-item');
            
            upsellItem.find('.item-price .sale').html(upsellPrice);
            upsellItem.find('.item-title').html(upsellTitle);
            upsellItem.find('.item-img').remove(); 
            upsellItem.prepend(upsellImg);
            upsellItem.find('.item-desc').html(upsellDescription).addClass('active');
        } else if (!$(this).hasClass('step4-upsell')) {
            const upsellItem = $('.trial-items-wrap .upsell-item');
            upsellItem.find('.item-price .sale').html('');
            upsellItem.find('.item-title').html('');
            upsellItem.find('.item-img').remove();
            upsellItem.find('.item-desc').empty();
        }
        calculateTotalPrice();
    });
    
    function calculateTotalPrice() {
        let total = 0;
        let prefix = '';
        let suffix = '';
        
        $('.trial-items-wrap .item-price .sale').each(function(i) {
            const txt = $(this).text().trim();
            
            if (i === 0) {
                // try prefix first, otherwise suffix
                const mPre = txt.match(/^(\D+?)(?=\s*\d)/);
                const mSuf = txt.match(/(\D+?)$/);
                if (mPre) {
                    prefix = mPre[1].trim() + ' ';
                } else if (mSuf) {
                    suffix = ' ' + mSuf[1].trim();
                }
            }
            
            // Normalize price: replace comma with dot if comma is used as decimal separator
            let normalized = txt.replace(/[^0-9,.-]+/g, '');
            // If both comma and dot exist, assume comma is thousands separator, remove it
            if (normalized.indexOf(',') > -1 && normalized.indexOf('.') > -1) {
                normalized = normalized.replace(/,/g, '');
            } else if (normalized.indexOf(',') > -1) {
                // If only comma, replace with dot for decimal
                normalized = normalized.replace(/,/g, '.');
            }
            const num = parseFloat(normalized);
            if (!isNaN(num)) total += num;
        });
        
        $('.total-calculation .value').text(
            prefix + total.toFixed(2) + suffix
        );
    }
    
    
    $('.frequency-selector, .blend-selector, .step1-card, .next-step, .option-card').on('click', function () {
        chooseVariant();
    });
    
    if ($('.frequency-slider').length) {
        window.addEventListener('slider-change', function (event) { 
            chooseVariant();
        });
    }
    
    chooseVariant(); // Initial call to set the variant on page load
    
    // Function to only show the active blend selector
    function showActiveBlendSelector() {
        const activeBlend = $('.step1-card.active').data('handle');
        $('.product-variant-selection').each(function () {
            $(this).removeClass('active');
            if ($(this).data('handle') === activeBlend) {
                $(this).addClass('active');
            } else {
                
            }
        });
    }
    
    // Dynamic product type selection
    
    $('.step1-card').on('click', function () { 
        let trialPrice = $(this).data('trial-price');
        $('.trial-items-wrap').find('.variant-item').find('.item-price .sale').html(trialPrice);
        let originalProduct = $(this).data('full-product-title');
        $('.future-items-wrap').find('.what-you-get').text(originalProduct);
        let originalPrice = $(this).data('full-price');
        $('.future-items-wrap').find('.when-value .price-value').text(originalPrice);
        showActiveBlendSelector();
        handleFrequencySelection();
        
    });
    
    // Dynamic frequency selection
    function handleFrequencySelection() {
        const activeStep = $('.step1-card.active').index('.step1-card');
        const activeHandle = $('.step1-card.active').data('handle');
        let plan, days;
        if (activeStep === 0) {
            if ($('.frequency-selector').is('select')) {
                plan = $('.frequency-selector option:selected').data('plan-value1');
                days = $('.frequency-selector option:selected').data('shipment-day1');
            } else {
                plan = $('.frequency-selector.active').data('plan-value1');
                days = $('.frequency-selector.active').data('shipment-day1');
            }
        } else if (activeStep === 1) {
            if ($('.frequency-selector').is('select')) {
                plan = $('.frequency-selector option:selected').data('plan-value2');
                days = $('.frequency-selector option:selected').data('shipment-day2');
            } else {
                plan = $('.frequency-selector.active').data('plan-value2');
                days = $('.frequency-selector.active').data('shipment-day2');
            }
        } else if (activeStep === 2) {
            if ($('.frequency-selector').is('select')) {
                plan = $('.frequency-selector option:selected').data('plan-value3');
                days = $('.frequency-selector option:selected').data('shipment-day3');
            } else {
                plan = $('.frequency-selector.active').data('plan-value3');
                days = $('.frequency-selector.active').data('shipment-day3');
            }
        }
        
        
        if (days) {
            const date = new Date();
            date.setDate(date.getDate() + Number(days));
            const formattedDate = date.toLocaleDateString('en-GB');
            $('.next-charge').text(formattedDate);
        }
        
        
        $('.option-selection')
        .find('select[data-handle="' + activeHandle + '"]')
        .find('option[data-frequency="' + plan + '"]')
        .prop('selected', true);
        let frequencyText = $('.trial-frequency[data-handle="' + activeHandle + '"]').find('option:selected').text();
        $('.future-items-wrap').find('.when-value .plan-value').text(frequencyText);
    }
    
    $('.frequency-selector').on('click', handleFrequencySelection);
    
    window.addEventListener('slider-change', function () {
        console.log('slider changed');
        handleFrequencySelection();
    });
    
    // Trigger click on all active option cards
    $('.option-card.active').each(function () {
        $(this).trigger('click');
    });
    
    // Free gift logic
    
    function handleFreeGiftSelection() { 
        if ($('.step3b-card').length) { 
            let freeGiftVariant = $('.step3b-card.active').data('upsell-id');
            let freeGiftPrice = $('.step3b-card.active').data('upsell-price');
            let freeGiftTitle = $('.step3b-card.active').data('gift-name');
            let freeGiftImg = $('.step3b-card.active .free-gift-img').clone().addClass('item-img');
            $('.free-item .item-title').text(freeGiftTitle);
            $('.free-item .item-price .sale').text(freeGiftPrice);
            $('.free-item .item-img').remove(); // Remove previous image if any
            $('.free-item').prepend(freeGiftImg);
        }
    }
    
    $('.step3b-card').on('click', function () { 
        handleFreeGiftSelection();
    });
    
    handleFreeGiftSelection(); // Initial call to set the free gift on page load
    
    // Dynamic checkout
    $('.cta-btn.checkout').on('click', function () {
        const activeBlend = $('.step1-card.active').data('handle');
        const variant = $('.product-variant-select[data-handle="' + activeBlend + '"]').val();
        const sellingPlan = $('.trial-frequency[data-handle="' + activeBlend + '"]').val();
        if (variant && sellingPlan) {
            const mainItem = {
                id: variant,
                quantity: 1,
                selling_plan: sellingPlan
            };
            
            let upsellItem;
            
            // Upsell
            if ($('.step4-upsell').hasClass('active')) {
                const upsellVariant = $('.step4-upsell.active').data('upsell-id');
                upsellItem = {
                    id: upsellVariant,
                    quantity: 1
                };
            } 
            
            let freeGiftItem;
            
            // Free gift
            if ($('.step3b-card').length && $('.step3b-card.active').hasClass('active')) {
                freeGiftVariant = $('.step3b-card.active').data('upsell-id');
                freeGiftItem = {
                    id: freeGiftVariant,
                    quantity: 1
                };
            }
            
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error clearing cart: ' + response.statusText);
                }
                const items = [mainItem];
                if (upsellItem) {
                    items.push(upsellItem);
                }
                if (freeGiftItem) {
                    items.push(freeGiftItem);
                }
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: items
                    })
                });
            })
            .then(response => {
                if (response.ok) {
                    window.location.href = '/checkout';
                } else {
                    console.error('Error adding item to cart:', response);
                }
            })
            .catch(error => {
                console.error('Cart operation failed:', error);
            });
        }
    });
    
    // Dynamic steps
    
    function dynamicSteps() {
        let current = $('.stepBar.active');
        let next, prev;
        // Check if prev-step was clicked
        if ($(event.target).hasClass('prev-step')) {
            prev = current.prev('.stepBar');
            if (prev.length) {
                current.removeClass('active');
                prev.addClass('active');
            }
        } else {
            next = current.next('.stepBar');
            if (next.length) {
                current.removeClass('active');
                next.addClass('active');
            }
        }
        let activeStep = $('.stepBar.active').index();
        $('.subscription-step').removeClass('active');
        $('.subscription-step').each(function (index) {
            if (index == activeStep) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });
        
        if (activeStep === 0) {
            $('.prev-step').attr('disabled', true);
        } else {
            $('.prev-step').attr('disabled', false);
        }
        
        // Show or hide the step-footer based on whether it's the last step
        if (activeStep === $('.stepBar').length - 1) {
            $('.trial-navigation').hide();
        } else {
            $('.trial-navigation').show();
        }
    }
    
    $('.option-card, .next-step, .prev-step').on('click', function () {
        dynamicSteps();
        showActiveBlendSelector();
    });
    
    $('.edit-step').on('click',function(){
        // go to fist step
        $('.stepBar').removeClass('active');
        $('.stepBar').first().addClass('active');
        $('.subscription-step').removeClass('active');
        $('.subscription-step').first().addClass('active');
        // Scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'fast');
    });
    
    // Checking if there is only one product in first stap
    
    if ($('.step1-card').length === 1) { 
        $('.subscription-step').first().addClass('active');
        updateActiveStep();
        $('.stepBar').first().addClass('active');
    } else {
        $('.subscription-step-1').addClass('subscription-step active');
        updateActiveStep();
        $('.stepBar').first().addClass('active');
    }
    
    // Summary tabs switch 
    $('.tabs-head .tab').on('click', function () { 
        const tabId = $(this).data('id');
        $('.tabs-head .tab').removeClass('active');
        $(this).addClass('active');
        $('.tabs-content .content').removeClass('active');
        $('.tabs-content .content[data-tab-id="' + tabId + '"]').addClass('active');
    });
    
    // Trial FAQs 
    
    $('.faqs-lists').find('.faq-head').on('click', function () {
        $(this).toggleClass('active');
        $(this).next('.faq-desc').slideToggle();
    });
    
    // Blends info popup 
    
    $('.step-popup-atc').on('click', function () { 
        $(this).closest('.step-container').find('.introduction-popup').toggleClass('active');
    });
    
    $('.toggle-popup').on('click', function () { 
        $(this).closest('.introduction-popup').removeClass('active');
    });
});
